import { render, staticRenderFns } from "./LessonReservationDlg.vue?vue&type=template&id=b4ecd3e2&scoped=true&"
import script from "./LessonReservationDlg.vue?vue&type=script&lang=js&"
export * from "./LessonReservationDlg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4ecd3e2",
  null
  
)

export default component.exports